// polyfill for IE 11
if (typeof window !== 'undefined' && !window.crypto) {
  window.crypto = window.msCrypto;
}
